import type { Module } from "@webmotors/ioc";
import { CryptoModule } from "../crypto";
import { LoggerModule } from "../logger";
import { CookieService } from "./cookie.service";

export const CookieModule: Module = {
  name: "CookieModule",
  modules: [LoggerModule, CryptoModule],
  providers: [CookieService],
};
